// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"b2b732c4","228":"54846486","466":"4324fe7b","521":"94c9cd69","586":"3051e95a","928":"951594a1"}[chunkId] + ".chunk.js";
};